module.exports = __webpack_public_path__ + "img/landing_page_2.c90822f5.png";